import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale020,
  scale030,
  scale100,
  scale110,
  scale130,
  scale140,
  scale150,
  scale200,
  spaceS,
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorInfo,
  xdlColorInfoSoft,
  xdlColorHoverSecondary,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: calc(${scale020} + ${scale200});
`;

export const Title = styled(Headline)`
  margin-bottom: ${scale130};
`;

export const Text = styled(BodyCopy)`
  margin-bottom: calc(${scale020} + ${scale140});
`;

export const CardContainer = styled.div`
  background-color: ${xdlColorHoverSecondary};
  margin: 0 -${scale100};
  padding: ${scale150};

  @media ${mediaConfined} {
    border-radius: ${scale110};
    margin: 0;
    padding: ${spaceXL};
  }
`;

export const BulletPointsContainer = styled.div`
  background-color: ${xdlColorInfoSoft};
  border-left: ${scale030} solid ${xdlColorInfo};
  margin: 0 -${scale100} ${scale150};
  padding: ${spaceXXL} ${scale100};

  @media ${mediaConfined} {
    margin: 0 0 ${scale150};
    padding: ${spaceXXL};
  }

  & > ul {
    margin: 0;
    padding-left: ${scale100};
  }
`;

export const BulletPointTitle = styled.li<{ noMargin?: boolean }>`
  font-size: ${scale100};
  font-weight: bold;
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : `${spaceL}`)};

  @media ${mediaConfined} {
    margin-bottom: ${({ noMargin }) => (noMargin ? 0 : `${spaceXL}`)};
  }
`;

export const BulletPointBody = styled(BodyCopy)`
  margin: ${spaceS} 0 0;
`;
